/**
 * Modal Components for Travel Demo
 * 
 * Receipt pack modal and other modal components.
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Receipt } from 'lucide-react';
import { ReceiptPackEntry } from './shared';

// Receipt Pack Modal
export const ReceiptPackModal = ({ isOpen, onClose, receiptPack }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
        <div className="p-4 border-b border-slate-700 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Receipt className="w-5 h-5 text-cyan-400" />
            <span className="font-semibold text-white">Journey Evidence Pack</span>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} className="text-slate-400 hover:text-white">
            ✕
          </Button>
        </div>
        
        <div className="p-4 border-b border-slate-700 bg-slate-800/30">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-cyan-400">{receiptPack?.length || 0}</div>
              <div className="text-xs text-slate-500">Governance Steps</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-emerald-400">
                {receiptPack?.filter(r => r.data_shared?.length > 0).length || 0}
              </div>
              <div className="text-xs text-slate-500">Data Shared</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-rose-400">
                {receiptPack?.filter(r => r.data_withheld?.length > 0).length || 0}
              </div>
              <div className="text-xs text-slate-500">Data Withheld</div>
            </div>
          </div>
        </div>
        
        <div className="p-4 overflow-y-auto max-h-[calc(80vh-200px)] space-y-3">
          {receiptPack?.map((entry, i) => (
            <ReceiptPackEntry key={entry.receipt_id || i} entry={entry} index={i} />
          ))}
        </div>
        
        <div className="p-4 border-t border-slate-700 bg-slate-800/30">
          <div className="text-xs text-slate-500 text-center">
            All governance steps recorded with journey episode references.
            Each receipt is independently verifiable.
          </div>
        </div>
      </div>
    </div>
  );
};
